import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);
let defaultLocale = "de"

if (localStorage.getItem ("language")) {
  defaultLocale = localStorage.getItem("language")
}

export const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: "en",
  messages: {
    en: require("./en.json"),
    de: require("./de.json"),
    ru: require("./ru.json")
  }
});
